<template>
    <section id="services" class="services">
        <div class="services__background">
            <div class="wrapper">
                <div class="services__background__top">
                    <div class="services__background__top__image" 
                        data-aos="fade-up"
                        data-aos-delay="50"
                        data-aos-duration="1000"
                        data-aos-easing="ease-in-sine"
                        data-aos-once="true"></div>
                    <div class="services__background__top__text">
                        <h2 class="title">We are helping</h2>
                        <p>
                            In TreeTopTrip we think good software is a must have. That’s why we help our partners organise all software development stages, including requirements collection & business analysis, product ownership, project management, implementation, quality assurance & testing.
                        </p>
                    </div>
                </div>
                <div class="services__background__bottom">
                    <div class="services__background__bottom__text">
                        <h2 class="title">We are strong</h2>
                        <p>
                            Are you struggling with web-based software, cloud solutions or DevOps? Frontend? Backend? Don’t worry, it’s dead easy for us! We are strong both in participating in legacy projects and delivering end-to-end solutions. External audits and professional consultancy services are also a part of our life!
                        </p>
                    </div>
                    <div class="services__background__bottom__image"
                        data-aos="fade-up"
                        data-aos-delay="50"
                        data-aos-duration="1000"
                        data-aos-easing="ease-in-sine"
                        data-aos-once="true"></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'services',
    }
</script>

<style lang="scss" scoped>
    .services {
        width: 100%;
        height: 1800px;
        
        &__background {
            background-image: url("../assets/stripes.png");
            height: 100%; 
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            background-size: 100% 100%;
            display: flex;
            flex-direction: column;

            .title {
                font-family: kazimir, sans-serif;
                font-size: 4em;
                position: relative;
                margin-bottom: 40px;
                transition: ease-in-out .4s;

                &::after {
                    content: '';
                    position: absolute;
                    height: 2px;
                    background-color: #ff5400;
                    top: calc( 100% + 10px);
                    width: 15%;
                    left: 0;
                }
            }

            &__top,
            &__bottom {
                width: 100%;
                height: 50%;
                display: flex;
                align-items: center;
                justify-content: space-around;

                &__image,
                &__text {
                    max-width: 50%;
                }

                &__image {
                    background-position: center;
                    background-size: cover;
                    border-radius: 50%;
                    width: 350px;
                    height: 350px;
                }
            }

            &__top {
                top:0;
                &__image {
                    background-image: url("../assets/helping.jpg");
                }
            }

            &__top:hover h2.title{
                color: #ff5400;
            }

            &__bottom:hover h2.title{
                color: #ff5400;
            }

            &__bottom {
                bottom: 0;
                padding-bottom: 430px;
                &__image {
                    background-image: url("../assets/strong.jpg");
                }
            }
        }
    }

    @media all and (max-width: 1200px) {
        .services__background__top,
        .services__background__bottom {
            &__image {
                width: 300px;
                height: 300px;
            }
        }
    }

    @media all and (max-width: 970px) {
        .services {
            height: 1600px;

            &__background {
                background-size: 158%;
                height: calc(100% + 325px);

                .title {
                    font-size: 3.5em;
                }

                &__top,
                &__bottom {
                    &__image {
                        width: 270px;
                        height: 270px;
                    }
                }
            }
        }
        
    @media all and (max-width: 830px) {
        .services {

            &__background {
                background-size: 185%;

                .title {
                    font-size: 3em;
                    padding: 0 40px;
                    &::after {
                        left: 40px;
                    }
                }

                &__bottom {
                    padding-bottom: 0px;
                    justify-content: flex-start;
                }

                &__top {
                    justify-content: center;
                }

                &__top,
                &__bottom {
                    flex-direction: column;

                    &__text {
                        max-width: initial;
                    }

                    &__image {
                        margin-top: 20px;
                        order: 2;
                        width: 230px;
                        height: 230px;
                    }
                }
            }
        }
    }

    @media all and (max-width: 785px) {
        .services {
            // height: 1500px;

            &__background {
                height: calc(100% + 400px);
                background-size: 210%;
            }
        }
    }

    @media all and (max-width: 685px) {
        .services {
            height: 1600px;

            &__background {
                background-size: 245%;
            }
        }
    }

    @media all and (max-width: 600px) {
        .services__background {
            background-size: 280%;
        }
    }

    @media all and (max-width: 530px) {
        .services {
            height: 1500px;

            &__background {
                height: calc(100% + 320px);
                background-size: 250%;

                .title {
                    font-size: 2em;
                }

                &__top,
                &__bottom {
                    &__image {
                        width: 150px;
                        height: 150px;
                    }
                }
            }
        }
    }

    @media all and (max-width: 500px) {
        .services {
            &__background {
                background-size: 290%;
            }
        }
    }

    @media all and (max-width: 440px) {
        .services {
            &__background {
                background-size: 330%;
            }
        }
    }

    @media all and (max-width: 400px) {
        .services {
            &__background {
                background-size: 380%;
            }
        }
    }

    @media all and (max-width: 370px) {
        .services {
            &__background {
                background-size: 420%;
            }
        }
    }

    @media all and (max-width: 330px) {
        .services {
            &__background {
                background-size: 480%;
            }
        }
    }
}
</style>